<template>
    <div>
        <img class="grey-bg">
        <a-row>
            <a-col :span="24">
                <a-list item-layout="horizontal" :data-source="supplierData" :pagination="paginationProps">
                    <a-list-item slot="renderItem" slot-scope="item, index">
                        <a-list-item-meta
                                :description="'邀请时间:'+formatDate2(item.invitationDate)">
                            <p slot="title" class="color-black size5 mb-0"> <B><span style="color:#ff9a0f;cursor: pointer;"  >[联合体报名]</span><a
                                    href="javascript:;"  style="color: rgba(0, 0, 0, 0.65);"> {{item.invitationSupplierName }}邀请贵公司联合投标{{ item.xmmc }}({{item.bzxh}})</a></B></p>
                        </a-list-item-meta>
                        <span slot="actions">
                                  <a-button type="danger" @click="onSetInvitation(item,'2')" :loading="Loading">拒绝</a-button>
                                  <a-button class="ml-2" type="primary" @click="onSetInvitation(item,'1')" :loading="Loading">接受</a-button>
                            </span>
                    </a-list-item>
                </a-list>
            </a-col>
        </a-row>
    </div>
</template>
<script>
    import {PageView} from '@/layouts'
    import moment from 'moment'
    import qs from  'qs'
    export default {
        name: 'SupplierLhtInvitation2',
        components: {
            PageView
        },
        created() {
            // this.onLoad()
        },
        data() {
            return {
                Loading: false,
                paginationProps: {
                    showTotal: (total, range) => {
                        return " 共" + total + "条"
                    },
                    defaultPageSize: 5,
                    pageSizeOptions: ['5', '8', '10', '12'],
                    showQuickJumper: false,
                    showSizeChanger: true,
                },
                supplierData: [],
                modalLoading: false,
            }
        },
        methods: {
            formatDate2(date, format) {
                if (date) {
                    return moment(date).format(format || 'YYYY-MM-DD')
                }
                return ''
            },
            onSetInvitation(item,val){
                let that = this
                const params ={
                    id:item.id,
                    invitationRespondStatus:val
                }
                that.$http.post('/api/v1/supplier/lht/setLhtInvitation.json',qs.stringify(params)).then(function (res) {
                    if (200!=res.code)
                    {
                        that.$message.error(res.msg)
                        return
                    }
                    that.onLoad()
                    that.$message.success(res.msg)
                })
            },
            onLoad() {
                let that = this
                that.Loading = true
                this.$http.get('/api/v1/supplier/lht/getListBySupplierId.json').then(function (res) {
                    that.Loading = false
                    that.supplierData = res.result
                });
            },
        }
    }
</script>

<style scoped>
    .handle {
        background: none;
    }

    .handle .right a {
        margin-left: 30px;
    }

    .grey-bg {
        position: relative;
        left: 50%;
        margin-left: -960px;
    }

    .t1-icon {
        position: absolute;
        top: -38px;
        font-size: 40px;
        left: 0;
        right: 0;
        width: 80px;
        height: 80px;
        line-height: 80px;
        background: #fff;
        border-radius: 40px;
        margin: auto;
    }

    .t1-text {
        text-align: center;
        position: relative;
        z-index: 99;
        font-size: 18px;
    }

    /deep/ .ant-avatar {
        border-radius: 0;
        background: none;
    }

    /deep/ .ant-avatar-string {
        transform: scale(1) translateX(-50%) !important;
    }

    .icon {
        width: 32px;
        height: 32px;
        line-height: 34px;
        vertical-align: top;
        border-radius: 4px;
    }

    .sound {
        background: #e6f7ff;
        color: #1890ff;
        border: 1px solid #91d5ff;
    }

    .user {
        background: #f6ffed;
        color: #52c41a;
        border: 1px solid #b7eb8f;
    }
</style>
